module.exports = __webpack_public_path__ + "static/img/success.cd409dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/success.png
// module id = K3IM
// module chunks = 1